/** Canonical showing-time and create-response helpers. */

const SLOT_DURATION_MS = 60 * 60 * 1000;
const HTTP_BAD_REQUEST = 400;

export const INVALID_TIME_BLOCK_ERROR = 'Invalid time block provided';

/**
 * Convert a parseable instant to a canonical UTC ISO string.
 * @param {unknown} value
 * @returns {string | null}
 */
export function toCanonicalUtc(value) {
  const parsed = typeof value === 'number' ? value : Date.parse(value);
  if (typeof parsed !== 'number' || Number.isNaN(parsed)) {
    return null;
  }

  return new Date(parsed).toISOString();
}

/**
 * True when a value is already in canonical UTC ISO form.
 * @param {unknown} value
 * @returns {boolean}
 */
export function isCanonicalUtc(value) {
  return typeof value === 'string' && toCanonicalUtc(value) === value;
}

/**
 * Derive the existing one-hour showing end from a canonical UTC start.
 * @param {string} startUtc
 * @returns {string | null}
 */
export function deriveSlotEndUtc(startUtc) {
  const canonical = toCanonicalUtc(startUtc);
  if (!canonical) {
    return null;
  }

  return toCanonicalUtc(Date.parse(canonical) + SLOT_DURATION_MS);
}

/**
 * True when an axios-style error is the stale-selection invalid-time contract.
 * @param {unknown} error
 * @returns {boolean}
 */
export function isInvalidTimeBlockResponse(error) {
  const response = error && typeof error === 'object' ? error.response : null;
  return isBadRequestWithInvalidTime(response);
}

/**
 * @param {{ status?: number, data?: { error?: string } } | null | undefined} response
 * @returns {boolean}
 */
function isBadRequestWithInvalidTime(response) {
  if (!response || response.status !== HTTP_BAD_REQUEST || !response.data) {
    return false;
  }

  return response.data.error === INVALID_TIME_BLOCK_ERROR;
}
